import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Router} from "@angular/router";
import {ToastService} from "./toast.service";
import {AppUser} from "../dtos/AppUser";
import {filter, Observable, Subscription, take} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {catchError, map, tap} from "rxjs/operators";
import {AuthService} from "./auth.service";
import {environment} from "../../environments/environment";
import {updateUser} from "../state/auth/auth.actions";
import {selectUpdateUserFailure, selectUpdateUserSuccess} from "../state/auth/auth.selectors";
import {Store} from "@ngrx/store";
import {AppState} from "../state/app.state";
import {PopupService} from "./popup.service";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  loggedIn: any = false;
  hubSpotConnection : any = false;
  users: any;
  // @ts-ignore
  user: any;
  // @ts-ignore
  userRole: string;
  interval: any;
  token: any;
  private apiUrl = environment.api.url;
  redirectUrl: string | null = null;

  getApiUrl() {
    console.log(this.apiService.apiUrl)
    return this.apiService.apiUrl;
  }

  constructor(
    private apiService: ApiService,
    private router: Router,
    private toastService: ToastService,
    private authService:AuthService,
    private http: HttpClient,
    private store: Store<AppState>,
    private popupService:PopupService,
  ) {
  }

  setCustomInterval(time: number, func: () => void) {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(func, time);
  }

  clearCustomInterval() {
    clearInterval(this.interval);
  }

  // User details
  getUserProfilePicture() {
    if (this.user !== undefined && this.user !== null) {
      return this.getApiUrl() + this.user.picture;
    }
    return '/assets/img/report-pic.png';
  }

  getUserName() {
    if (this.user !== undefined && this.user !== null) {
      return [this.user.first_name, this.user.last_name].join(' ');
    }
    return "Welcome";
  }

  getUserEmail() {
    if (this.user !== undefined && this.user !== null) {
      return this.user.email;
    }
    return false;
  }

  getUserPhone() {
    if (this.user !== undefined && this.user !== null) {
      return this.user.phone;
    }
    return false;
  }

  // @ts-ignore
  async login(params) {
    await this.apiService.csrf();
    return this.apiService.doRequest('login', 'POST', params);
  }

  async authenticateWithLinkedInToken(params){
    await this.apiService.csrf();
    return this.apiService.doRequest('api/users/linkedin-token-login', 'POST', params);
  }

  async checkAuth(){
    await this.apiService.csrf();
    let authResponse = await this.apiService.doRequest('api/users/me', 'GET', []);

    this.loggedIn = !!authResponse;
    if(this.loggedIn){
      this.user = authResponse.data;
      console.log(this.user);
    }
    return this.loggedIn;
  }

  // @ts-ignore
  async register(params) {
    console.log('register');
    this.getApiUrl();

    await this.apiService.csrf();

    this.logout();

    const response = this.apiService.doRequest('register', 'POST', params);
    console.log('register response:');
    console.log(response);
    return response;
  }

  // @ts-ignore
  /*
  async forgotPassword(params) {
    await this.apiService.csrf();
    return this.apiService.doRequest('forgot-password', 'POST', params);
  }
  */

  async forgotPassword(params) {
    try {
      return await this.apiService.doRequest('api/v1/password/email', 'POST', params);
    } catch (error) {
      console.error('Password reset error:', error);
      throw error;
    }
  }

  // @ts-ignore
  async updatePassword(params) {
    await this.apiService.csrf();
    return this.apiService.doRequest('api/v1/password/reset', 'POST', params);
  }

  changePassword(params){
    return this.apiService.doRequest('api/users/change-password', 'POST', params);
  }

  updateProfile(params){
    return this.apiService.doRequest('api/users/update-profile', 'POST', params);
  }

  async updateAvatar(params){
    return this.apiService.doRequest('api/users/update-avatar', 'POST', params, false, {}, null, true);
  }
  disconnectHubspot(params) {
    return this.apiService.doRequest('api/users/hubspot-disconnect', 'POST', params);
  }

  disconnectGoogle(params) {
    return this.apiService.doRequest('api/users/google-disconnect', 'POST', params);
  }

  updateUser(user_id): Observable<{ user: any}> {


    this.authService.token().subscribe(token => {
      this.token = token;
    });
    const url = `${this.apiUrl}/users/` + user_id;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept'  : 'application/json',
        'Accept-Language': 'en',
        'Authorization': `Bearer ${this.token}` // Use the token here
      })
    };

    return this.http.get<any>(url,httpOptions ).pipe(
      map(response => {
        if (!response) {
          // If the token is not present in the response, throw an error
          throw new Error('Update user failed: No token received');
        }
        console.log('Update User response:', response);
        return {
          user: response.data
        }
      }),
      catchError(error => {
        throw error;
      })
    );
  }




  logout() {
    console.log('logout')
    this.loggedIn = false;
    UserService.handleClearedStorage();
    this.apiService.doRequest('logout', 'POST', []);
    this.router.navigate(['/']);
  }

  // @ts-ignore
  getAvatar(path) {
    return this.getApiUrl() + path;
  }

  static handleClearedStorage() {
    localStorage.clear();
  }

  update_state_user(){

    this.authService.authUser().subscribe(user => {
      this.user = user;
    })

    this.store.dispatch(updateUser({ user: this.user }));

    // Listen for the login success or failure from the store
    const updateUserSuccess$ = this.store.select(selectUpdateUserSuccess);
    const updateUserFailure$ = this.store.select(selectUpdateUserFailure);

    let updateUserSuccessSubscription: Subscription = null;
    let updateUserFailureSubscription: Subscription = null;

    // Subscribe to the login success
    updateUserSuccessSubscription = updateUserSuccess$.pipe(
      tap((data) => console.log(data)),
      filter(data => data.user != null), // Filter for the success condition
      take(1) // Take the first occurrence
    ).subscribe({
      next: (data) => {
        // Handle success


        if (updateUserSuccessSubscription) {
          updateUserSuccessSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
      },
      error: (error) => {
        // Handle error
        console.error('Update user error:', error);

        if (updateUserSuccessSubscription) {
          updateUserSuccessSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
      }
    });

    // Subscribe to the login failure
    updateUserFailureSubscription = updateUserFailure$.pipe(
      filter(failure => failure !== null), // Filter for the failure condition, assuming failure is null when there's no error
      take(1) // Take the first occurrence
    ).subscribe({
      next: (error) => {
        // Handle failure
        const errorMessage = error.error.error.message
        this.popupService.notify(errorMessage, 'Login error', 'error');

        if (updateUserFailureSubscription) {
          updateUserFailureSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
      },
      error: (error) => {
        // Handle error in error handling
        console.error('Update user error handling error:', error);

        if (updateUserFailureSubscription) {
          updateUserFailureSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
      }
    });
  }

}

